import React from 'react';
import Model from '@tripian/model';
import LogoutIcon from '../base/Svg/Icons/Logout';
import CheckCircle from '../base/Svg/Icons/CheckCircle';
import classes from './SocialLoginSignoutPage.scss';

type Props = {
  t?: (key: Model.TranslationKey) => string;
  remainingSeconds?: number;
};

const SocialLoginSignoutPage: React.FC<Props> = ({
  t = (key: Model.TranslationKey) => '',
  remainingSeconds
}) => {
  return (
    <div className={classes.signoutContainer}>
      <div className={classes.signoutContent}>
        <div className={classes.iconWrapper}>
          <div className={classes.iconCircle}>
            <LogoutIcon size="32px" />
          </div>
          <div className={classes.checkIcon}>
            <CheckCircle size="20px" />
          </div>
        </div>
        
        <h1 className={classes.title}>
          {t('auth.logout.title')}
        </h1>
        <p className={classes.message}>
          {t('auth.logout.message')}
        </p>
        <div className={classes.redirectWrapper}>
          <p className={classes.redirectMessage}>
            {remainingSeconds} {t('auth.logout.redirect')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SocialLoginSignoutPage;